import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// import { getArtisanAction } from "../../../../modules/artisans/Actions";
import {
  getSinglePendingArtisanAction,
  moderateCreateSinglePendingArtisan,
  getPendingArtisansAction
} from '../../../../modules/artisanModeration/artisans/Actions';

import { getArtisanCategoriesAction } from '../../../../modules/artisanCategories/Actions';

import { artisanCategoryByIdSelector } from '../../../../modules/artisanCategories/Selectors';

import { updatePendingArtisanAction } from '../../../../modules/artisanModeration/artisans/Actions';
import {
  artisansIsLoadingSelector,
  artisanByIdSelector
} from '../../../../modules/artisans/Selectors';

import {
  pendingArtisanByIdSelector,
  pendingArtisansSelector
} from '../../../../modules/artisanModeration/artisans/Selectors';

import { Formik } from 'formik';

import {
  InputField,
  Upload,
  TextArea,
  Select,
  SearchableSelect,
  CheckBox,
  FormSectionTitle,
  Separator
} from '../../../../components/form/';

import ArtisanBIOi18n from '../../../../components/form/i18nForm/FormBIOi18n';
import WorkingHours from '../../../../components/form/WorkingHours';
import ModerationForm from '../../../../components/form/ModerationForm';
import { pendingArtisansIsLoadingSelector } from '../../../../modules/artisanModeration/artisans/Selectors';
import { get } from 'object-path';
import getLangData from '../../../../utils/getLangData';
import { button } from 'react-bootstrap';
import axiosInstance from '../../../../helpers/api';
import { errorNotificationFromError } from '../../../../modules/notifications/Actions';
// import artisans from ".";
// import { values } from "lodash";

const companySizeOptions = [
  {
    label: '1-10',
    value: '1-10'
  },
  {
    label: '10-100',
    value: '10-100'
  },
  {
    label: '100-1000',
    value: '100-1000'
  },
  {
    label: 'More Than 1000',
    value: '1000+'
  }
];

const options = [
  {
    value: ['0'],
    label: 'Workshop'
  },
  {
    value: ['1'],
    label: 'Distributor'
  },
  {
    value: ['2'],
    label: 'Shop'
  }
];

const ViewPendingArtisan = props => {
  // artisans
  const {
    getArtisan,
    artisan,
    artisanId,
    moderationId,
    artisansIsLoading,
    updateArtisan,
    pendingArtisansIsLoading,
    getSinglePendingArtisan,
    getCategories,
    artisanCategories,
    moderateArtisan,
    getArtisans,
    errorNotificationFromError
  } = props;
  const lang = getLangData().fields
  useEffect(() => {
    getCategories({ size: 50 });
    // getSinglePendingArtisan(artisanId);
    getArtisans();
    getPendingArtisansAction();
  }, [getSinglePendingArtisan, artisanId]);


  console.log(artisanCategories, !artisan || !artisanCategories || artisanCategories?.length === 0, 'artisanCategoriesartisanCategories')
  if (!artisan || !artisanCategories || artisanCategories?.length === 0) return <></>

  return (
    <Formik
      enableReinitialize
      onSubmit={values => {
        moderateArtisan(
          {
            id: artisanId
          },
          values.moderationType
        );
      }}
      initialValues={{ ...artisan }}
    >
      {({ values, handleSubmit }) => (
        <>
          <ModerationForm
            isDisabled={false}
            isLoading={artisansIsLoading || pendingArtisansIsLoading}
            handleSubmit={handleSubmit}
            heading={artisan ? `${lang.view} [${artisan.businessName}]` : null}
          >
            <FormSectionTitle>{lang.basic_information}:</FormSectionTitle>
            {/* <SearchableSelect
            name='userID'
            label='User'
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
          /> */}
            <SearchableSelect
              isMulti
              getItems={getCategories}
              name='categoryData'
              label={lang.artisan_category}
              options={artisanCategories}
            />
            <InputField name='businessName' label={lang.business_name} />
            <Select
              inArray={true}
              options={options}
              name='businessType'
              label={lang.busience_type}
            />
            <Upload
              data={{ artisanID: props.userID }}
              name='logo'
              label={getLangData().fields.logo}
              S3Bucket='warshatna-users'
              API='artisan/artisan-profile-logo-signedurl/'
            />
            <TextArea name='artisanBIO' label={lang.artisan_bio} />
            <ArtisanBIOi18n name='artisanBIOi18n' />

            <Separator />
            <FormSectionTitle>{lang.company_and_store}</FormSectionTitle>
            <CheckBox
              name='onlineStore'
              label={lang.online_store}
              subLabel={getLangData().general_words.i_have_online_store}
            />
            <CheckBox
              name='offlineStore'
              label={lang.offline_store}
              subLabel={getLangData().general_words.i_have_offline_store}
            />
            <InputField name='yearEstablished' label={lang.year_established} />
            <CheckBox
              name='regCompany'
              label={lang.registered_company}
              subLabel={getLangData().general_words.i_have_registered_company}
            />
            <Select
              options={companySizeOptions}
              name='companySize'
              label={lang.company_size}
            />

            <Separator />
            <FormSectionTitle>{lang.contact_person_details}</FormSectionTitle>
            <InputField name='contactPerson' label={lang.contact_person} />
            <InputField name='contactPersonTitle' label={lang.contact_person_title} />
            <InputField name='contactPersonPhone' label={lang.contact_person_phone} />
            <InputField name='contactPersonEmail' label={lang.contact_person_email} />
            <Separator />
            <FormSectionTitle>{lang.company_and_store}</FormSectionTitle>
            <InputField name='website' label={lang.website} />
            <InputField name='facebook' label={lang.facebook} />
            <InputField name='instagram' label={lang.instagram} />
            <InputField name='youtube' label={lang.youtube} />
            <Separator />
            <FormSectionTitle>{lang.working_hours} :</FormSectionTitle>
            <WorkingHours name='workingHours' />
            <Separator />

          </ModerationForm>
          <button className="btn btn-secondary mb-3" onClick={async () => {
            try {
              let data = values;
              delete data.geolocation;
              await axiosInstance.put(`/artisan/${data.artisanID}`, data);
              await axiosInstance.delete(`/artisan-staging/${artisan._id}`);
              window.location.href = '/artisans-moderation/artisans'
            } catch (error) {
              errorNotificationFromError(error)
            }
          }} >{lang.edit_approve}</button></>

        // artisanID
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const artisanId = props.match.params.artisanId;
  const moderationId = props.match.params.moderationId;

  let categoryId;

  // console.log(state.artisanCategories, 'statestate')
  return {
    categoryId,
    moderationId,
    artisanId,
    artisansIsLoading: artisansIsLoadingSelector(state),
    pendingArtisansIsLoading: pendingArtisansIsLoadingSelector(state),
    // artisan: artisanByIdSelector(state, artisanId),
    artisan: pendingArtisanByIdSelector(state, artisanId),
    artisanCategory: artisanCategoryByIdSelector(state, categoryId),
    artisanCategories: state.artisanCategories.items,
    userID: state.auth.user._id
  };
};

const mapDispatchToProps = {
  moderateArtisan: moderateCreateSinglePendingArtisan,
  // getArtisan: getArtisanAction,
  getSinglePendingArtisan: getSinglePendingArtisanAction,
  getCategories: getArtisanCategoriesAction,
  getArtisans: getPendingArtisansAction,
  errorNotificationFromError
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPendingArtisan);
